import React from "react";

/**
 * @component InvoicesIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <InvoicesIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const InvoicesIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="InvoicesIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path d="M15.19 4H5v16h14V7.891L15.19 4zM5 2h11.03L21 7.075V20a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2zm4.974 11.752c-.01.532.13.952.42 1.26.29.308.649.504 1.078.588v-2.926a3.017 3.017 0 00-.448-.126 11.322 11.322 0 01-1.022-.329 3.337 3.337 0 01-.903-.504 2.325 2.325 0 01-.637-.784c-.159-.313-.238-.702-.238-1.169 0-.476.091-.896.273-1.26.182-.364.422-.67.721-.917a3.291 3.291 0 011.036-.574 4.667 4.667 0 011.218-.245V5.688h.826v1.078c.42.047.814.138 1.183.273.369.135.693.322.973.56.28.238.509.534.686.889.177.355.28.775.308 1.26H13.46a1.472 1.472 0 00-.35-.952c-.224-.261-.495-.392-.812-.392v2.478l.343.084a9 9 0 01.371.098c.69.187 1.223.418 1.596.693.373.275.649.562.826.861.177.299.282.597.315.896.033.299.049.565.049.798 0 .205-.051.464-.154.777a2.62 2.62 0 01-.553.917c-.266.299-.623.565-1.071.798-.448.233-1.022.373-1.722.42v1.19h-.826v-1.19c-1.045-.075-1.862-.397-2.45-.966-.588-.57-.929-1.405-1.022-2.506h1.974zm2.324 1.848c.168-.019.343-.058.525-.119a1.63 1.63 0 00.49-.259 1.38 1.38 0 00.357-.413c.093-.163.14-.357.14-.581 0-.364-.114-.637-.343-.819-.229-.182-.618-.348-1.169-.497V15.6zm-.826-7.196a1.54 1.54 0 00-.462.07 1.22 1.22 0 00-.406.217c-.121.098-.217.22-.287.364-.07.145-.105.315-.105.511 0 .308.098.546.294.714.196.168.518.303.966.406V8.404z" />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
    </svg>
  )
);
InvoicesIcon.displayName = "InvoicesIcon";
export default InvoicesIcon;
